import { createStore } from "zustand";

export type TFeatureFlagStore = {
  flags: Set<string>;
};

const createFeatureStore = () => {
  const store = createStore<TFeatureFlagStore>(() => ({
    flags: new Set<string>(),
  }));

  return store;
};

const FeatureFlagStoreContext = createFeatureStore();

export default FeatureFlagStoreContext;
